import qs from 'query-string';
import { ReferralTransactionSnapshot } from '../../models/Referral/Statement/ReferralTransaction';
import { ReferralEvent, ReferralLedgerStatus } from '../../constants/referral';
import api, { rawClient } from '../api';
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';

const getTransactions = (): Promise<ReferralTransactionSnapshot[]> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/statement`,
    });
};

type ReferralStatementReportFilter = {
    minDate?: string;
    maxDate?: string;
    event?: ReferralEvent;
    status?: ReferralLedgerStatus;
    description?: string;
};

const getStatementReport = (
    filters: ReferralStatementReportFilter
): Promise<void> => {
    return rawClient.download({
        url: `${getBackVersion()}/referral/statement/download`,
        params: decamelizeKeys(filters),
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'none' });
        },
    });
};

export { getTransactions, getStatementReport };
export type { ReferralStatementReportFilter };
